import { useTranslation } from 'react-i18next'

import ActionList from '../components/table/components/ActionList'
import TableActions from '../components/table/components/TableActions'

const useTableHooks = (actions) => {
  const { t } = useTranslation()

  const tableHooks = (hooks) => {
    // Recompute visible columns on language change so the header gets translated
    hooks.visibleColumnsDeps.push((deps) => [...deps, t])
    hooks.visibleColumns.push((columns) => [
      ...columns,
      {
        id: 'action',
        Header: t('actions'),
        Cell: ({ row }) => {
          return (
            <TableActions>
              <ActionList actions={actions} row={row} />
            </TableActions>
          )
        },
      },
    ])
  }

  return tableHooks
}

export default useTableHooks
